angular.module('workflow')
    .controller('WorkflowSelectController', function ($scope, $rootScope, $uibModalInstance, data, Workflow, WorkflowService) {
        this.WorkflowService = WorkflowService;
        this.reset = () => this.filters = this.primaryFilters
        this.filters = data;

        this.$onInit = () => {
            this.primaryFilters = angular.copy(this.filters)
            this.directions = WorkflowService.getDirections()
            this.loadData()
        }
        this.select = selected => $uibModalInstance.close(selected)
        this.cancel = () => $uibModalInstance.dismiss('cancel')

        this.loadData = () => {
            let filters = angular.copy(this.filters);
            Workflow.allGranted(filters).$promise.then(result => this.items = result)
        }

        this.isAlreadySelected = (id) => {
            return this.filters.alreadySelectedIds instanceof Array && this.filters.alreadySelectedIds.includes(id);
        }
    })
